import { MediaInputStorage } from "@/services/storage/base/media-input-storage";
import { AnonServiceUsageStorage } from "@/services/storage/base/anon-service-usage-storage";

class BeatMachineSessionStorage extends MediaInputStorage {
  constructor() {
    super("beatMachineCache", "BeatMachineRemoverDB");
  }
}

class BeatMachineUsageCountStorage extends AnonServiceUsageStorage {}

const beatMachineUsageStorage = new BeatMachineUsageCountStorage(
  "beatMachineUsageKey",
  "beatMachineUsageStore",
  "beatMachineUsageDB",
);
const beatMachineSessionStorage = new BeatMachineSessionStorage();
export { beatMachineSessionStorage, beatMachineUsageStorage };
